<template>
  <Panel lineColor="var(--primary-color)" class="variaveis-panel">
    <div class="variaveis-panel-inner">
      <div class="variaveis-panel-head">
        <p class="variaveis-titulo">
          <v-icon size="14" color="primario">fas fa-tags</v-icon>
          Variáveis
        </p>
        <p class="variaveis-ajuda">
          Clique em uma variável para inserir
          <code v-pre>{{ token }}</code> no editor.
        </p>
      </div>

      <div class="variaveis-panel-scroll">
        <div v-if="!grupos.length" class="variaveis-vazio">
          Nenhuma variável para este documento.
        </div>

        <div
          v-for="grupo in grupos"
          :key="grupo.categoria"
          class="variaveis-grupo"
        >
          <p class="variaveis-categoria">{{ grupo.categoria }}</p>
          <div
            v-for="item in grupo.itens"
            :key="item.chave"
            class="variavel-linha"
            :class="{
              'variavel-linha--coluna': item.chave.indexOf('.') !== -1
            }"
          >
            <button
              type="button"
              class="variavel-badge"
              :title="item.descricao"
              @click="$emit('inserir', item.chave)"
            >
              <v-icon size="12" class="variavel-badge-icon"
                >fas fa-plus-circle</v-icon
              >
              <span class="variavel-token">{{ formatToken(item.chave) }}</span>
              <span class="variavel-tipo">{{ labelTipo(item.tipo) }}</span>
            </button>
            <button
              type="button"
              class="variavel-copiar"
              title="Copiar token"
              @click="copiarToken(item.chave, $event)"
            >
              <v-icon size="12">fas fa-copy</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import {
  formatVariavelToken,
  TIPO_VARIAVEL_LABEL,
  agruparVariaveisPorCategoria
} from "../template-documentos.constants";

export default {
  name: "TemplateDocumentosVariaveisPanel",
  components: { Panel },
  props: {
    variaveis: { type: Object, default: () => ({}) }
  },
  computed: {
    grupos() {
      return agruparVariaveisPorCategoria(this.variaveis);
    }
  },
  methods: {
    formatToken(chave) {
      return formatVariavelToken(chave);
    },
    labelTipo(tipo) {
      return TIPO_VARIAVEL_LABEL[tipo] || tipo || "Texto";
    },
    async copiarToken(chave, event) {
      event?.stopPropagation();
      const token = formatVariavelToken(chave);
      try {
        await navigator.clipboard.writeText(token);
        this.$vueOnToast.pop(
          "success",
          "Token copiado para a área de transferência."
        );
      } catch (e) {
        this.$vueOnToast.pop("error", "Não foi possível copiar o token.");
      }
    }
  }
};
</script>

<style scoped>
.variaveis-panel {
  max-height: 100%;
  text-align: left;
}

.variaveis-panel-inner {
  display: flex;
  flex-direction: column;
  max-height: 470px;
  overflow: hidden;
}

.variaveis-panel-head {
  flex-shrink: 0;
}

.variaveis-panel-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.variaveis-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  margin-bottom: 6px;
}

.variaveis-ajuda {
  font-size: 0.85rem;
  color: #6b7280;
  margin-bottom: 12px;
}

.variaveis-ajuda code {
  background: #f9f2f4;
  color: #c7254e;
  padding: 1px 4px;
  border-radius: 3px;
}

.variaveis-categoria {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9ca3af;
  margin: 10px 0 6px;
}

.variavel-linha {
  display: flex;
  align-items: stretch;
  gap: 6px;
  margin-bottom: 6px;
}

.variavel-linha--coluna {
  margin-left: 16px;
}

.variavel-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  text-align: left;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 8px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.variavel-badge:hover {
  background: #f0fdf4;
  border-color: var(--primary-color, #17654a);
}

.variavel-copiar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.variavel-copiar:hover {
  background: #f0fdf4;
  border-color: var(--primary-color, #17654a);
  color: var(--primary-color, #17654a);
}

.variavel-token {
  font-family: ui-monospace, monospace;
  font-size: 0.78rem;
  color: #be185d;
  flex: 1;
}

.variavel-tipo {
  font-size: 0.7rem;
  color: #6b7280;
  white-space: nowrap;
}

.variaveis-vazio {
  color: #9ca3af;
  font-size: 0.9rem;
}
</style>
